import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  Button,
  ModalCloseButton,
  RootDrawerToggle,
} from "@towersystems/roam-common-native";
import { SaleRootParamList, ValidSetupRootParamList } from "../../../../types";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { ExportModalRootScreen } from "../ExportModelRootScreen";
import { ReceiptsModalRootScreen } from "../ReceiptsModalRootScreen";
import { SaleScreen } from "../SaleScreen";
import { SalesListScreen } from "../SalesListScreen";
import { useTranslation } from "../../../../utilities/i18n";
import { useActiveLocation } from "../../../../utilities/app-state/hooks";
import { useListFilter } from "../../../../utilities/list-filter";
import { ListFilterProvider } from "../../../../utilities/list-filter/use-list-filter-context";
import { SalesListFilterRootScreen } from "../SalesListFilterRootScreen";
import { SalesFilterValues } from "../../types";
import { defaultSaleFilterValues } from "../../common";
import { SaleSource } from "@towersystems/roam-common/lib/generated-types";
import { ViewProformaScreen } from "../../../point-of-sale/screens/ActionCreateProformaSaleRootScreen/ViewProformaScreen";
import { Colors } from "react-native-ui-lib";
import { AiInsightsRootModalScreen } from "../../../point-of-sale/screens/AiInsightsScreens/AiInsightsRootModalScreen";
import { ProductAiInsightsRootModalScreen } from "../../../point-of-sale/screens/ProductAiInsightsScreens";

export interface SalesRootScreenProps
  extends StackScreenProps<
    ValidSetupRootParamList & SaleRootParamList,
    "SalesRootScreen"
  > {}

const SalesRoot = ({ navigation }: SalesRootScreenProps) => {
  const { t } = useTranslation("sales");
  const RootNavigator = createStackHeaderNavigator<SaleRootParamList>();
  return (
    <RootNavigator.Navigator>
      <RootNavigator.Group
        screenOptions={{
          headerLeft: () => <RootDrawerToggle />,
        }}
      >
        <RootNavigator.Screen
          name="SalesListScreen"
          component={SalesListScreen}
        />
        <RootNavigator.Screen
          name="SaleScreen"
          options={{
            title: "",
            animationEnabled: true,
            headerTitleAlign: "center",
            headerLeft: () => <ModalCloseButton type="Back" />,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
          component={SaleScreen}
        />
      </RootNavigator.Group>
      <RootNavigator.Group
        screenOptions={{
          presentation: "modal",
          animationEnabled: true,
          cardStyle: { backgroundColor: Colors.surface },
        }}
      >
        <RootNavigator.Screen
          name="ReceiptsModalRootScreen"
          options={{
            headerShown: false,
          }}
          component={ReceiptsModalRootScreen}
        />
        <RootNavigator.Screen
          name="ExportModalRootScreen"
          options={{
            headerShown: false,
          }}
          component={ExportModalRootScreen}
        />
        <RootNavigator.Screen
          name="SalesListFilterRootScreen"
          component={SalesListFilterRootScreen}
          options={{
            headerShown: false,
          }}
        />
        <RootNavigator.Screen
          name="ViewProformaScreen"
          component={ViewProformaScreen}
          options={{
            headerShown: true,
            title: "",
            headerLeft: () => <ModalCloseButton type="Close" />,
          }}
        />
        <RootNavigator.Screen
          name="AiInsightsRootModalScreen"
          component={AiInsightsRootModalScreen}
          options={{ headerShown: false }}
        />
        <RootNavigator.Screen
          name="ProductAiInsightsRootModalScreen"
          component={ProductAiInsightsRootModalScreen}
          options={{ headerShown: false }}
        />
      </RootNavigator.Group>
    </RootNavigator.Navigator>
  );
};
export const SalesRootScreen = (props: SalesRootScreenProps) => {
  const { locationId } = useActiveLocation();

  const filterContext = useListFilter<SalesFilterValues>({
    defaultValues: {
      ...defaultSaleFilterValues,
      locationId: [locationId],
      source: [SaleSource.WEB_REGISTER],
    },
  });

  return (
    <ListFilterProvider {...filterContext}>
      <SalesRoot {...props} />
    </ListFilterProvider>
  );
};
